import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/defaults/')({
  beforeLoad: () => {
    throw redirect({
      to: '/overdue',
      search: { tab: 'defaults' },
    });
  },
  component: () => null,
});
